// extracted by mini-css-extract-plugin
export var block = "paint-plan-module--block--dEAJm";
export var container = "paint-plan-module--container--XpKak";
export var details = "paint-plan-module--details--VqeGU";
export var error = "paint-plan-module--error--YIVRX";
export var meta = "paint-plan-module--meta--ZR7kA";
export var miniatureItem = "paint-plan-module--miniatureItem--7TBbE";
export var miniatureList = "paint-plan-module--miniatureList--3t2u5";
export var miniatureMeta = "paint-plan-module--miniatureMeta--n2Pad";
export var miniatureTitle = "paint-plan-module--miniatureTitle--uc2WE";
export var statCard = "paint-plan-module--statCard--qnR0l";
export var statValue = "paint-plan-module--statValue--joD+y";
export var status = "paint-plan-module--status--nfNTX";
export var summaryGrid = "paint-plan-module--summaryGrid---FoxS";